import { useAuth } from '@src/main/shared/context/AuthContext';
import Footer from '@src/main/shared/ui/components/footer/Footer';
import NavbarLayout from '@src/main/shared/ui/layout/NavbarLayout';
import { type FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import styles from './MainLayout.module.scss';

const MainLayout: FC = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className={styles.layout}>
      <NavbarLayout>
        <Outlet />
      </NavbarLayout>
      <Footer />
    </div>
  );
};

export default MainLayout;
